<template>
  <v-flex xs12 sm6 md4 class="px-2 date-range-wrapper">
    <div class="date-range-fieldset" role="group" :aria-label="title">
      <div class="date-range-legend">
        <v-icon small class="mr-1" aria-hidden="true">mdi-calendar-range</v-icon>
        <span class="caption font-weight-medium">{{ title }}</span>
      </div>
      <div class="date-range-content">
        <v-layout row wrap>
          <v-flex xs12 sm6 class="pr-1">
            <v-menu
              ref="fromDateMenu"
              v-model="fromDateMenuLocal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="localValue.from"
                  readonly
                  clearable
                  dense
                  hide-details
                  :placeholder="$i18n.t('Date From')"
                  v-on="on"
                  class="filter-field"
                  :aria-label="`${title} from date`"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localValue.from"
                no-title
                scrollable
                @input="fromDateMenuLocal = false"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 class="pl-1">
            <v-menu
              ref="toDateMenu"
              v-model="toDateMenuLocal"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="localValue.to"
                  readonly
                  clearable
                  dense
                  hide-details
                  :placeholder="$i18n.t('Date To')"
                  v-on="on"
                  class="filter-field"
                  :aria-label="`${title} to date`"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localValue.to"
                no-title
                scrollable
                @input="toDateMenuLocal = false"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  name: "DateRangeFilter",
  props: {
    value: {
      type: Object,
      required: true
    },
    fromDateMenu: {
      type: Boolean,
      required: true
    },
    toDateMenu: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: "Date Range"
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    fromDateMenuLocal: {
      get() {
        return this.fromDateMenu;
      },
      set(value) {
        this.$emit("update:fromDateMenu", value);
      }
    },
    toDateMenuLocal: {
      get() {
        return this.toDateMenu;
      },
      set(value) {
        this.$emit("update:toDateMenu", value);
      }
    }
  }
};
</script>

<style scoped>
.date-range-wrapper {
  display: flex;
  justify-content: center;
}

.filter-field {
  margin-bottom: 4px;
  padding: 0;
}

.filter-field::v-deep .v-input__slot {
  min-height: 36px !important;
  border: none;
}

.filter-field::v-deep input {
  font-size: 13px;
  padding: 0;
}

.filter-field::v-deep input::placeholder {
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-weight: 500;
}
.filter-field::v-deep .v-input--is-focused input::placeholder,
.filter-field::v-deep .v-input--is-dirty input::placeholder {
  color: transparent;
}

.date-range-fieldset {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 12px 8px 8px;
  margin-bottom: 8px;
  width: 100%;
}

.date-range-legend {
  position: absolute;
  top: -10px;
  left: 8px;
  padding: 0 4px;
  background-color: white;
  display: flex;
  align-items: center;
  height: 20px;
  color: rgba(0, 0, 0, 0.87);
}

.date-range-content {
  margin-top: 2px;
}
.filter-field::v-deep .v-input__slot:focus-within {
  outline: 2px solid #2196f3;
  outline-offset: 2px;
}
.filter-field::v-deep .v-input__slot:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
